import { render } from "./multipleSelect.vue?vue&type=template&id=19f99f58&scoped=true"
import script from "./multipleSelect.vue?vue&type=script&lang=js"
export * from "./multipleSelect.vue?vue&type=script&lang=js"

import "./multipleSelect.vue?vue&type=style&index=0&id=19f99f58&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f99f58"]])

export default __exports__